import type { PromptDocument } from '../types'
import type { PlatformRenderer } from './index'

/**
 * Google Imagen prefers natural-language paragraphs over comma-separated tags.
 * We lightly "sentence-ify" each section:
 *   - Each enabled section becomes one sentence.
 *   - Tags inside the section are joined with ", " (Oxford-comma style).
 *   - Sentences end with `.`.
 *   - Negative prompts are appended as: "Avoid X, Y, Z."
 *   - MJ numeric params are dropped; aspect ratio is written out in words.
 */
export const imagenRenderer: PlatformRenderer = {
  id: 'imagen',
  label: 'Google Imagen',
  render(doc) {
    const sentences = doc.sections
      .filter(s => s.enabled)
      .slice()
      .sort((a, b) => a.order - b.order)
      .map((s) => {
        const inner = s.tags.map(t => t.raw.trim()).filter(Boolean).join(', ')
        return inner ? `${inner}.` : ''
      })
      .filter(Boolean)

    const negatives = doc.params.no?.map(n => n.trim()).filter(Boolean) ?? []
    if (negatives.length)
      sentences.push(`Avoid ${negatives.join(', ')}.`)

    if (doc.params.ar)
      sentences.push(`Aspect ratio ${doc.params.ar}.`)

    return sentences.join(' ')
  },
}
